import { AfterViewInit, Component, OnInit, ViewChild, NgZone, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { FilterPipe } from '../../pipes/filter.pipe';
import { NewPackageService } from '../../services/NewPackage.service';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';


class packages {
  packageCode: string;
  packageOwnership: string;
  packageName: string;
  lastUpdate: string;
  currentStatus: string;
  description: string;
}

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.scss']
})
export class PackageComponent implements OnInit,AfterViewInit,OnDestroy {
  allPkgsData: any;
  SMPkgsData: any;
  newLookupData: any;
  fusoLookupData: any;
  pkgFusoData: any;
  admitFusoEdit: boolean;
  adminFuso: any;
  pkgData: any;
  adminEdit: boolean;
  allPackages: any;
  fusoLookupList: any;
  NewLookupList: any;
  displayNew: boolean;
  packageLookupList: any;
  displayFuso: boolean;
  showSpinner: boolean;
  newPkgTableTrigger: boolean;
  fusoTrigger: boolean;
  tableTriggered: boolean = false;
  openfusoRequested: boolean;
  fusoPkgIdCreated: any;
  suppCode: any;
  userSuppCode: any;
  loginId: any;
  userRoleID: any;
  pkgIdCreated: any;
  item: any;
  pkgCodeId: any;
  openRequested: boolean;
  @ViewChild(DataTableDirective)

  datatableElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  packages: packages[] = [
    {
      packageCode: '',
      packageOwnership: '',
      packageName: '',
      lastUpdate: '',
      currentStatus: '',
      description: ''
    }
  ];
  fusoPackages: packages[] = [];
  // We use this trigger because fetching the list of persons can be quite long,
  // thus we ensure the data is fetched before rendering
  dtTrigger: Subject<any> = new Subject();
  message = '';
  modalRef: NgbModalRef;
  closeResult: string;
  sortingItem = "updatedDate";
  ascending = false;
  rowsPerPage: any=10;
  overallpackages: any;

  constructor(private newPackageService: NewPackageService, private modalService: NgbModal, private spinner: NgxSpinnerService,
    private translate: TranslateService, private route: ActivatedRoute, private router: Router) { 
    }
  ngAfterViewInit() {
   
  }
  ngOnDestroy() {
    this.dtTrigger.unsubscribe();
  }

  ngOnInit(): void {
    // this.dtOptions = {
    //   pagingType: 'full_numbers',
    //   pageLength: 10, // set the default number of items per page
    //   searching: true, // enable searching
    //   // Add any other DataTables options you need
    // };
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId;
    this.loginId = userDetJson.loginId;
    this.userSuppCode = userDetJson.supplierCode;
    if (this.userSuppCode != null) {
      this.suppCode = this.userSuppCode.toString();
    }
    this.dtOptions = {
      pagingType: 'simple_numbers',
      pageLength: 10,
      dom: '<"top"<"row"<"col-md-10 text-right"<"#dtpagination"p>><"col-md-2 text-right"<"#dtlength"l>><"clear">>><"#dtsearch_newPack"f>t<"bottom"<"clear">>',
      order: [[2, "desc"]],
      language: {
        emptyTable: this.translate.instant('No Records Found'),
        search: "_INPUT_",
        searchPlaceholder: this.translate.instant('Search By Package Code, Package Name'),
        paginate: {
          first: "",
          last: "",
          previous: "<",
          next: ">"
        }
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        // Unbind first in order to avoid any duplicate handler
        // (see https://github.com/l-lin/angular-datatables/issues/87)
        $('td', row).unbind('click');
        $('td', row).bind('click', () => {
        });
        return row;
      }
    };

    
    // this.spinner.show();
    this.getFusoPackageCode();
    this.getPackageCode();
    this.getAllApprovedPkgCode();
    this.getFusoApprovedList();
    this.getAllPackageCode();
   
    this.route.data.subscribe(v =>
      this.adminFuso = v.adminFuso);
  }

  getAllPackageCode() {
    if (this.userRoleID == 5 || this.userRoleID == 9) {
      this.spinner.show();
      this.newPackageService.getApprovedPkgCode().subscribe(
        result => {
          this.allPkgsData = result;
          this.allPackages = this.allPkgsData.response;
          this.spinner.hide();
        }
      )
    }
  }

  openPkgRequested(pkgRequested, pkgId) {
    this.openRequested = true;
    this.pkgIdCreated = pkgId;
    this.modalRef = this.modalService.open(pkgRequested, { size: 'lg', windowClass: 'detail-modal',backdrop:false })
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    });
  }

  openFusoPkgRequested(fusoPkgRequested, fusoPkgId) {
    this.openfusoRequested = true;
    this.fusoPkgIdCreated = fusoPkgId;
    this.modalRef = this.modalService.open(fusoPkgRequested, { size: 'lg', windowClass: 'detail-modal',backdrop:false })
    this.modalRef.result.then((result) => {
    });
  }
  rowEdit(adminEdit, data) {
    this.adminEdit = true;
    this.pkgData = data.packageCode;
    this.modalRef = this.modalService.open(adminEdit, { size: 'lg', windowClass: 'detail-modal',backdrop:false })
    this.modalRef.result.then((result) => {
    });
  }

  rowEditFuso(editFusoDetails, data) {
    this.admitFusoEdit = true;
    this.pkgFusoData = data.fusoPackageCode;
    this.modalRef = this.modalService.open(editFusoDetails, { size: 'lg', windowClass: 'detail-modal',backdrop:false })
    this.modalRef.result.then((result) => {
    });
  }

  getPackageCode() {
    if (this.userRoleID == 1) {
      this.newPackageService.getAllPackage()
        .subscribe(packages => {
          if (packages.response != 'Response is empty') {
            this.packages=packages.response
            console.log("packages",this.packages)
          }
          this.spinner.hide();
          if (this.tableTriggered == false) {
            this.dtTrigger.next(true);
            // this.tableTriggered = true;
          }
        });
    }
    else if (this.userRoleID == 3) {
      this.newPackageService.getAllNewPackage()
        .subscribe(packages => {
          this.packages = packages.response;
          this.spinner.hide();
          if (this.tableTriggered == false) {
            this.dtTrigger.next(true);
            // this.tableTriggered = true;
            //  }
          }
        });

    }
    else if (this.userRoleID == 2 || this.userRoleID == 7) {
      this.newPackageService.getSMpackages().subscribe(
        result => {
          this.SMPkgsData = result;
          this.packages = this.SMPkgsData.response;
          this.spinner.hide();
          if (this.tableTriggered == false) {
            this.dtTrigger.next(true);
            // this.tableTriggered = true;
            //  }
          }
        })
    }
  }

  getFusoPackageCode() {
    // this.spinner.show();
    // this.fusoTrigger = true;
    if (this.userRoleID != 1) {
      this.newPackageService.getFusoPackage()
        .subscribe(
          fusoPackages => {
            this.fusoPackages = fusoPackages.response;
            this.spinner.hide();
            if (this.userRoleID == 4 || this.fusoTrigger == true) {
              this.dtTrigger.next(true);
            }
          })
    }
  }

  closeModal() {
    this.modalRef.close();
    this.tableTriggered = true;
    this.getPackageCode();
  }

  createdFuso() {
    this.tableTriggered = true;
    this.fusoTrigger = true;
    this.getFusoPackageCode();
  }

  closeAdmitEdit() {
    this.modalRef.close();
    this.getAllPackageCode()
  }

  closeAdminFusoEdit() {
    this.modalRef.close();
    this.getFusoApprovedList();
    this.router.navigate(['packageDashboard/AdminFusoPackage'])
  }
  showFusoList() {
    this.displayFuso = true;
  }

  showNewList() {
    this.displayNew = true;
  }

  getAllApprovedPkgCode() {
    if (this.userRoleID != 4) {
      this.newPackageService.getApprovedPkgCode().subscribe(
        result => {
          this.newLookupData = result;
          this.NewLookupList = this.newLookupData.response;
          // this.dtTrigger.next();
        });
    }
  }

  getFusoApprovedList() {
    if (this.userRoleID != 1) {
      this.newPackageService.getFusoPkgCode().subscribe(
        result => {
          this.fusoLookupData = result;
          this.fusoLookupList = this.fusoLookupData.response;
          // this.dtTrigger.next();
        }
      )
    }
  };
}